import React, { useState, useEffect } from 'react';

function VenueDisplay({Venue}){

    const [hasVenue, setHasVenue] = useState(false);
    const [venueName, setVenueName] = useState('');

    useEffect(() => {

        const venueAvailable = (Venue !== null && Venue !== undefined);

        setHasVenue(venueAvailable);

        if(venueAvailable){
            setVenueName(Venue.Name);
        }

        return () => {
            //cleanup here
            setHasVenue(false);
            setVenueName('');
        };
    },[Venue]);

    return(
<div>
    {hasVenue && (
    <div>
        <div>
            {venueName}
        </div>
    </div>
    )}
    
    {!hasVenue && (
        <div>
            No venue selected.
        </div>
    )}
</div>
    );
}

export default VenueDisplay;